import React, {useState} from 'react'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import UploadFileIcon from "@mui/icons-material/UploadFile";

import {useDataProviderState, useDataProviderActions} from '../../providers/DataProvider';

export default function FileUpload({label, upload, onUploadSuccess}) {

    const {uid} = useDataProviderState();
    const {setLoading, setErrorMessage} = useDataProviderActions();
    const [fileUploaded, setFileUploaded] = useState(false);
    const [filename, setFilename] = useState("");

    async function changeHandler(event) {
        const selectedFile = event.target.files[0];
        const {name} = selectedFile;

        setFilename(name);

        setLoading(true);

        const fileFormData = new FormData();
        fileFormData.append('upfile', selectedFile);

        const response = await upload(fileFormData, uid);

        if (response?.success) {
            setFileUploaded(true);
            onUploadSuccess();
        } else {
            setErrorMessage();
        }

        setLoading(false);
    }

    return (
        <Grid container spacing={{xs: 0, sm: 2}} alignItems="center" justifyContent="center">
            <Grid item sm={12} xs={12} sx={{pb: 0}} alignItems="center" justifyContent="center">
                <Grid item sm={12} xs={12} sx={{pb: 0}}>
                    <Box sx={{display: 'flex', justifyContent: 'center', pt: 2}}>
                        <Box sx={{alignItems: 'center'}}>
                            <Button
                                component="label"
                                variant="outlined"
                                startIcon={<UploadFileIcon/>}
                                sx={{width: '300px', border: '1px solid var(--color-primary)', p: 1, px: 3, borderRadius: 4, textTransform: 'uppercase'}}
                            >
                                {label}
                                <input type="file" hidden onChange={changeHandler}/> {/*accept="image/png, image/gif, image/jpeg"*/}
                            </Button>
                        </Box>
                    </Box>
                    <Box sx={{alignItems: 'center'}}>
                        {fileUploaded ? (
                            <Box display="flex" flexDirection="row" alignItems="center" justifyContent="center">
                                <Box>Archivo: {filename}</Box>
                                <Box sx={{
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    pl: 2,
                                    color: 'var(--color-primary)',
                                    fontSize: '2rem'
                                }} as="span">
                                    &#x2713;
                                </Box>
                            </Box>
                        ) : null}
                    </Box>
                </Grid>
            </Grid>
        </Grid>
    )
}
